import React from 'react';
import { ILinkedAccount } from '../../../types';
import { getBase64Image } from '../../../helpers/image.helpers';
import { ReactComponent as IconTrash } from '../../../assets/icons/svg/shared/ic-shared-trash.svg';
import { SUPPLIER_COLOR_MAP } from '../../Supplier/consts';
import { getProfileColorId } from '../../Supplier/helpers';

interface ILinkedAccountStripProps {
  account: ILinkedAccount;
  isSelected?: boolean;
  onClick: (selectedAccount: ILinkedAccount) => void;
  onRemoveClick: (accountExternalId: string) => void;
}

const STYLES = {
  WRAPPER:
    'h-[72px] w-[400px] bg-bw00 mb-[16px] last:mb-0 rounded-lg border-[1px] border-bw03 py-[10px] pl-[16px] pr-[26px] flex items-center justify-between hover:cursor-pointer group',
  MAIN: 'flex',
  BANK_ICON: 'w-[43px] h-[43px] rounded-full flex items-center justify-center',
  CONTENT_WRAPPER: 'max-w-[270px]',
  INSTITUTE_NAME: 'font-metricRMedium text-bw08 text-md truncate text-left',
  ACCOUNT_DETAILS: 'font-metricR text-bw07 text-sm truncate text-left',
  SELECTED: 'border-action03 bg-bw03 shadow-light_document',
  HOVER: 'hover:bg-bw02',
};

const getBankIcon = (logoStr: string | undefined) => {
  if (!logoStr) return '';
  return getBase64Image(logoStr);
};

const getLogoBackgroundColor = (id: number) =>
  SUPPLIER_COLOR_MAP[getProfileColorId(id.toString()) as keyof typeof SUPPLIER_COLOR_MAP];

export const LinkedAccountStrip = ({ account, isSelected, onClick, onRemoveClick }: ILinkedAccountStripProps) => {
  const institutionLogoSrc = getBankIcon(account?.institutionLogo);
  const hasLogoSrc = !!institutionLogoSrc;
  const handleUnlinkClick = (e: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
    e.stopPropagation();
    onRemoveClick(account?.externalId);
  };
  return (
    <button
      type='submit'
      data-testid='linkedAccountStrip-wrapper'
      className={`${STYLES.WRAPPER} ${STYLES.HOVER}`}
      onClick={() => onClick(account)}
    >
      <div className={STYLES.MAIN}>
        <div
          style={{ backgroundColor: `${!hasLogoSrc ? getLogoBackgroundColor(account?.id) : ''}` }}
          className='mr-[8px] rounded-full border-[1px] border-[#E4E4E4]'
        >
          {hasLogoSrc && (
            <img
              className={STYLES.BANK_ICON}
              src={institutionLogoSrc}
              alt='bank-logo'
              data-testid='linkedAccountStrip-image'
            />
          )}
          {!hasLogoSrc && <div className={STYLES.BANK_ICON}>{account?.institutionName[0]}</div>}
        </div>
        <div className={STYLES.CONTENT_WRAPPER}>
          <div className={STYLES.INSTITUTE_NAME} data-testid='linkedAccountStrip-instituteName'>
            {account?.institutionName}
          </div>
          <div
            className={STYLES.ACCOUNT_DETAILS}
            data-testid='linkedAccountStrip-accountDetails'
          >
            {`${account?.displayName}, ${account?.mask}`}
          </div>
        </div>
      </div>
      <div>
        <IconTrash
          className={`${isSelected ? 'inline-block' : 'hidden'} stroke-bw07 group-hover:inline-block`}
          data-testid='linkedAccountStrip-unlink'
          onClick={handleUnlinkClick}
        />
      </div>
    </button>
  );
};
